import React from 'react';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';

export interface CheckboxPropsI {
  checked?: boolean;
  label?: string;
  onChange: (value: boolean) => void;
  onClick?: () => void;
  variant?: 'outline';
  style?: React.CSSProperties;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxPropsI> = ({ checked, label, onChange, onClick, variant, style, disabled }) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClick && onClick();
  };

  return (
    <label
      className={classNames({
        [styles.container]: variant !== 'outline',
        [styles.container_outline]: variant === 'outline',
        [styles.container_disabled]: disabled
      })}
      onClick={handleClick}
      {...{style}}
    >
      {label}
      <input
        type="checkbox"
        disabled={disabled || false}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onClick={handleClick}
      />
      <span
        className={classNames({
          [styles.checkmark]: variant !== 'outline',
          [styles.checkmark_outline]: variant === 'outline'
        })}
        onClick={handleClick}
      ></span>
    </label>
  );
};

export default Checkbox;
